import type { Patient } from '@medplum/fhirtypes';
import { getBillingRoles } from './billingRoleFlags';
import type { AdminClientsListRow } from './types';

function telecomValue(patient: Patient, system: 'email' | 'phone'): string | undefined {
  return patient.telecom?.find((t) => t.system === system)?.value;
}

function patientDisplayName(patient: Patient): string {
  const name = patient.name?.[0];
  if (!name) return 'Unknown';
  const given = name.given?.join(' ') || '';
  const family = name.family || '';
  return `${given} ${family}`.trim() || 'Unknown';
}

/** FHIR Patient → list row (Medplum). */
export function mapMedplumPatientToListRow(patient: Patient): AdminClientsListRow | null {
  const id = patient.id;
  if (!id) return null;

  const name = patient.name?.[0];
  const givenParts = name?.given ?? [];
  const legalFirstName = givenParts.join(' ') || '—';
  const legalLastName = name?.family?.trim() || '—';
  const { isGuarantor, isSubscriber } = getBillingRoles(id);

  return {
    id,
    recordType: 'client',
    displayName: patientDisplayName(patient),
    legalFirstName,
    legalLastName,
    dateOfBirth: patient.birthDate,
    isGuarantor,
    isSubscriber,
    email: telecomValue(patient, 'email'),
    phone: telecomValue(patient, 'phone'),
    clientChartUrl: `/dashboard/clients/${id}`,
    sourceLabel: 'Client',
  };
}
